import { HttpInterceptorFn } from '@angular/common/http';

import { BROWSER_SESSION_ID_HEADER, getBrowserSessionId } from './browser-session-id';

export const browserSessionHttpInterceptor: HttpInterceptorFn = (request, next) => {
  const browserSessionId = getBrowserSessionId();
  if (!browserSessionId || request.headers.has(BROWSER_SESSION_ID_HEADER)) {
    return next(request);
  }

  return next(
    request.clone({
      setHeaders: {
        [BROWSER_SESSION_ID_HEADER]: browserSessionId
      }
    })
  );
};
